<template>
	<div class="footer">
		<div class="footer-div">
			<p><a href="https://beian.miit.gov.cn/" style="color: #999;text-decoration-line: none;" target="_blank">粤ICP备2022147555号</a></p>
			<p>版权所有：深圳市微云思维科技有限公司 </p>
			<!-- <p>电话：13172626336</p> -->
			<p>邮箱：m15820475158@163.com</p>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return{
				
			}
		},
		created() {
			
		},
		methods:{
			
		}
	}
</script>

<style>
	.footer{
		width: 100%;
		/* height: 137px; */
		background: #0b0101;
		/* position: absolute;
		bottom: 0;
		left: 0; */
	}
	.footer-div{
		color: #999;
		width: 100%;
		max-width: 1250px;
		text-align: center;
		padding: 20px 0;
		margin: 0 auto;
	}
</style>